import React from 'react'
import { AnimatedBackground } from '../organisms/AnimatedBackground'
import { AuthError } from '../../auth/authTools'

interface LoginTemplateProps {
  children?: React.ReactNode
  error?: AuthError | null
  className?: string
}

export const LoginTemplate: React.FC<LoginTemplateProps> = ({
  children,
  error,
  className = '',
}) => {
  return (
    <AnimatedBackground error={error} className={className}>
      {children}
    </AnimatedBackground>
  )
} 